import CompanyColdStorageSearch from './CompanyColdStorageSearch'

export default function CompanyColdStorage(): React.JSX.Element {
    return (
        <div className="mt-6">
            <CompanyColdStorageSearch syncWithUrl />
        </div>
    )
}
